export function navigatePath(path: string, numPages: number): string {
  const segments = path.split("/");
  return segments.slice(0, numPages).join("/");
}

export function trimStringWithEllipsis(input: string, maxLength: number): string {
  if (input.length <= maxLength) {
    return input;
  }

  let trimmedString = input.substring(0, maxLength);

  if (trimmedString.charAt(trimmedString.length - 1) === ' ') {
    trimmedString = trimmedString.replace(/\s+$/, '');
  }

  return trimmedString + '...';
}
